import { connect } from 'react-redux';

import { doDismissUserAlert, fetchUser } from "../actions/users";
import AlertBanner from '../components/AlertBanner';


const mapDispatchToProps = (dispatch) => {
  return {
    dismissAlert: (userId, alertId) => {
      dispatch(doDismissUserAlert(userId, alertId))
      .then(() => dispatch(fetchUser(userId)));
    }
  }
}

const container = connect(
  null,
  mapDispatchToProps
)(
  AlertBanner
);


export default container;


// WEBPACK FOOTER //
// ./src/containers/AlertBanner.js